<template>
    <v-card class="ma-3 pa-5">
        <h4>Create New Growth Phase</h4>
        <v-row class="px-3">
            <v-text-field
                v-model="newGrowthPhase.phase_type"
                class="mr-3"
                type="text"
                label="Phase Type"
            />
            <v-btn
                class="ma-4"
                @click="createNewGrowthPhase"
                small
                color="primary"
            >
                Create
            </v-btn>
        </v-row>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'CreateGrowthPhaseCard',
    computed: {
        ...mapState('cultureGrowthPhase', ['newGrowthPhase']),
    },
    methods: {
        ...mapActions('cultureGrowthPhase', ['createGrowthPhase', 'fetchGrowthPhases']),
        async createNewGrowthPhase() {
            if (!this.newGrowthPhase.phase_type) {
                return alert('Please fill Phase Type field!')
            }
            await this.createGrowthPhase()
            await this.fetchGrowthPhases()
        },
    },
}
</script>

<style scoped>
</style>